

export function filterByArchived(item) {
	return item.archived;
}

export function filterByNotArchived(item) {
	return !filterByArchived(item)
}
